import { asMoney } from "utils/calcs";

interface SummaryCardProps {
  label: string;
  value: number;
  borderColor: string;
}

interface FormSummaryProps {
  netLoanAmount: number;
  totalConsolidated: number;
  totalCashOut: number;
  overLimit: boolean;
}

const SummaryCard = ({ label, value, borderColor }: SummaryCardProps) => {
  return (
    <>
      <div
        className={`min-w-[180px] flex-1 rounded-lg border-2 bg-white px-7 py-5 ${borderColor}`}
      >
        <div className="mb-1 text-sm font-medium tracking-wide text-brand-copy-light">
          {label}
        </div>
        <div className="text-2xl font-bold text-brand-copy-primary">
          £{asMoney(value, true)}
        </div>
      </div>
    </>
  );
};

const FormSummary = ({
  netLoanAmount,
  totalConsolidated,
  totalCashOut,
  overLimit,
}: FormSummaryProps) => {
  return (
    <div className="flex flex-wrap gap-4">
      <SummaryCard
        label="Loan Amount"
        value={netLoanAmount}
        borderColor="border-brand-green-dark"
      />
      <SummaryCard
        label="Consolidated Credit"
        value={totalConsolidated}
        borderColor={overLimit ? "border-red-800" : "border-brand-green-medium"}
      />
      <SummaryCard
        label="Cash Out"
        value={Math.max(0, totalCashOut)}
        borderColor="border-brand-orange-medium"
      />
    </div>
  );
};

export default FormSummary;
